import React, { useCallback, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Row, Col, Tabs } from "antd";

import Terms from "../../components/contracts/terms";
import { getEntity } from "../../modules/crudOperations";
import Contract from "../../components/contracts/contract";
import LoadError from "../../components/app/generic/loadError";
import { CLIENT_PLACEHOLDER } from "../../modules/httpFunctions";
import TableHeader from "../../components/app/generic/tableHeader";
import LoadSkeleton from "../../components/app/generic/loadSkeleton";

const { TabPane } = Tabs;

const Contracts = () => {
  const [client, setClient] = useState();
  const [loading, setLoading] = useState(true);
  const handleClientLoad = useCallback(() => {
    setLoading(true);
    setClient();
    getEntity("client", CLIENT_PLACEHOLDER, setLoading, setClient);
  }, []);
  useEffect(() => {
    handleClientLoad();
  }, [handleClientLoad]);

  return (
    <Row>
      <Col>
        <TableHeader
          title={
            <FormattedMessage
              id="contracts.header"
              defaultMessage="Obchodní podmínky a smlouvy"
            />
          }
        />
        {loading ? (
          <LoadSkeleton />
        ) : client === "e" ? (
          <LoadError
            message={
              <FormattedMessage
                id="contracts.error"
                defaultMessage="Při načítání klientských dat nastala chyba, zkuste to prosím znovu."
              />
            }
          />
        ) : (
          <Tabs defaultActiveKey="1" animated={false}>
            <TabPane
              key="1"
              tab={
                <FormattedMessage
                  id="contracts.terms"
                  defaultMessage="Obchodní podmínky a registrace"
                />
              }
            >
              <Terms client={client} onClientLoad={handleClientLoad} />
            </TabPane>
            <TabPane
              key="2"
              tab={
                <FormattedMessage
                  id="contracts.contract"
                  defaultMessage="Smlouvy a ceníky"
                />
              }
            >
              <Contract />
            </TabPane>
          </Tabs>
        )}
      </Col>
    </Row>
  );
};

export default Contracts;
